import $ from "jquery";
import BD_Block from "@bd-core/bd-block";
import BD_GAME_LOGIC from "@bd-core/game-logic";
import { compile } from "@bd-utils/handlerbars-helper";
import bdapi from "@bd-core/bd-api";

export class Block_Pre_Post_Game extends BD_Block {
  constructor() {
    super();

    this.type = "pre_post_test";
    this.templateID = "pre-post-test";
    this._serverSide = false;

    this.elms = {
      inputSlider: ".js-input-slider",
      inputText: ".js-answer",
      btnNext: ".btn-test-next",
      btnSubmit: "#btn-test-submit",
      answerRadio: ".js-answer-radio",
      step: ".js-onclick-step",
      placeHolder: ".slide-content-container",
    };

    this._events = this.getEvents();

    /* custom attributes */
    this.audio = false;
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "click",
        selector: elms.btnNext,
        handler: this.onNext,
      },
      {
        event: "click",
        selector: elms.btnSubmit,
        handler: this.onSubmit, // TODO submit to server
      },
      {
        event: "change",
        selector: elms.answerRadio,
        handler: this.onChangeRadio, // TODO submit to server
      },
      {
        event: "input",
        selector: elms.inputSlider,
        handler: this.onChangeSlider,
      },
      {
        event: "input",
        selector: elms.inputText,
        handler: this.onChangeAnswer,
      },
      {
        event: "input",
        selector: elms.inputSlider,
        handler: this.onSlidingAnswer.bind(this),
      },
      {
        event: "mousedown",
        selector: elms.inputSlider,
        handler: this.thumbHover.bind(this),
      },
      {
        event: "mouseup mouseleave",
        selector: elms.inputSlider,
        handler: this.thumbRelease.bind(this),
      },
      {
        event: "click",
        selector: elms.step,
        handler: this.onClickStep.bind(this),
      },
      {
        event: "mouseover",
        selector: elms.inputSlider,
        handler: this.mimicHover.bind(this),
      },
    ];
  }

  beforeInit() {
    this.render();
    this.setGameState();
    this.thumbSliderAppearance();
    this.initValue();
  }

  beforeDestroy() {
    $("#pageWrapper").removeClass("is-loading");
  }

  render() {
    const htmlTemplate = $("#" + this.templateID).html();
    const html = compile(htmlTemplate, this._data);
    $("#templateWrapper").html(html);
  }

  setGameState() {}

  /* ========= ELEMENT FUNCTION HANDLER ===============*/

  onChangeRadio(ctx) {
    const index = $(ctx.target).data("index");
    const selector = ".js-answer-radio-" + index + ":checked";
    const val = $(selector).val();
    const hiddenSelector = "#js-answer-radio-" + index.toString();
    $(hiddenSelector).val(val);
    ctx.currentTarget = hiddenSelector;
    this.onChangeAnswer(ctx);
  }

  onChangeAnswer(ctx) {
    const $element = $(ctx.currentTarget);
    const value = $element.val();

    const isWhitespace = this.isWhitespaceString(value) || !value;

    this.toggleSubmitBtn($(ctx.currentTarget), !isWhitespace);
  }

  isWhitespaceString = (str) => !str.replace(/\s/g, "").length;

  // Prevent User to bypass the slider without inputing any answer
  onChangeSlider(ctx) {
    const $element = $(ctx.currentTarget);
    const value = $element.val();

    if (!value || this.isWhitespaceString(value)) return false;

    this.toggleSubmitBtn($(ctx.currentTarget), true);
  }

  toggleSubmitBtn($el, status = true) {
    let indx = $el.attr("answer-index");
    const $btn = $("button.btn-test-next[question-index=" + indx + "]");
    const isDisabled = $btn.attr("disabled") === "disabled";

    if (isDisabled && status) {
      $btn.removeAttr("disabled");
    }

    if (!isDisabled && !status) {
      $btn.attr("disabled", "disabled");
    }
  }

  onSlidingAnswer(e, $el) {
    const $parent = $el.parents(".slider__input");
    const $thumb = $parent.find(".js-slider-indicator");
    const $bubble = $thumb.find(".slider__thumb-text");
    const $step = $parent.find(".js-onclick-step");
    const val = $el.val();
    const min = $el.prop("min");
    const max = $el.prop("max");
    const newVal = Number(((val - min) * 100) / (max - min));
    const answerIndex = parseInt(val) - min;
    $bubble.html(val);
    $thumb.css("left", newVal + "%");
    $step.removeClass("is-current");

    $step.each(function () {
      const $stepIndex = $(this).data("index");
      if ($stepIndex == answerIndex) {
        $(this).addClass("is-current");
      } else {
        $(this).removeClass("is-current");
      }
    });

    $parent.find(".mark-index").removeClass("current sides");
    $parent
      .find(
        '.mark-index[data-index="' +
          (answerIndex - 1) +
          '"], .mark-index[data-index="' +
          (answerIndex + 1) +
          '"]',
      )
      .addClass("sides");
    $parent
      .find('.mark-index[data-index="' + answerIndex + '"]')
      .addClass("current");
  }

  onClickStep(e, $el) {
    const index = $el.data("index");
    const $parent = $el.parents(".slider__input");
    const $inputSlider = $parent.find(".js-input-slider");
    const min = parseInt($inputSlider.prop("min"));
    const val = min + index;
    $inputSlider.val(val);
    this.onSlidingAnswer(e, $inputSlider);

    if (!val) return false;

    this.toggleSubmitBtn($inputSlider, true);
  }

  thumbHover(e, $el) {
    const $parent = $el.parents(".slider__input");
    const $thumb = $parent.find(".js-slider-indicator");

    $thumb.addClass("is-transitioning");
  }

  thumbRelease(e, $el) {
    const $parent = $el.parents(".slider__input");
    const $thumb = $parent.find(".js-slider-indicator");

    $thumb.removeClass("is-transitioning");
  }

  initValue(e) {
    this.onSlidingAnswer(e, $(this.elms.inputSlider));
  }

  thumbSliderAppearance() {
    $(".js-input-slider").each(function () {
      const parentSlider = $(this).parents(".slider-test-page");
      const maxVal = $(this).prop("max");
      if (maxVal > 20) {
        parentSlider.find(".slider__placeholder").css({
          visibility: "hidden",
          width: "99%",
        });
        parentSlider.addClass("is-with-marks");
        parentSlider
          .find(".slider__step:not(:first-child):not(:last-child)")
          .css({
            visibility: "hidden",
          });
        parentSlider
          .find(
            ".slider__placeholder div:last-child, .slider__placeholder div:first-child",
          )
          .css({
            visibility: "visible",
            display: "auto",
          });
      } else {
        parentSlider.find(".slider__thumb").css("display", "none");
        parentSlider.addClass("is-markless");
      }
    });
  }

  onNext(ctx) {
    const currQuestionIndex = parseInt($(ctx.target).attr("question-index"));
    const nextIndex = currQuestionIndex + 1;
    const isEnd = nextIndex > this._data.questions.length;
    let dataVal = this._data;
    let val;
    if (typeof dataVal.pre_post_value !== "object") {
      dataVal.pre_post_value = [];
    }

    const type = $("#question-" + currQuestionIndex).attr("data-question-type");
    const emptyAnswerMsg = $("#question-" + currQuestionIndex).attr(
      "data-empty-answer",
    );

    if (type === "text" || type === "multiple_choice") {
      val = $(".input-question-" + currQuestionIndex).val();
      if (!val) {
        return alert(emptyAnswerMsg);
      }
    }

    if (type === "slider") {
      val = $("#question-" + currQuestionIndex)
        .find(".js-input-slider")
        .val();
    }

    if (val) {
      dataVal.pre_post_value.push(val);
      this._setData(dataVal);
    }

    if (isEnd) {
      $(".slide").removeClass("active");
      $("#test-end").css("display", "block").addClass("active");
      return;
    }

    if (type === "slider") {
      const $nextinputSlider = $("#question-" + nextIndex).find(
        ".js-input-slider",
      );
      // @ts-ignore
      const e = this.originalEvent;
      this.onSlidingAnswer(e, $nextinputSlider);
    }

    $("#question-" + currQuestionIndex).removeClass("active");
    $("#question-" + currQuestionIndex).addClass("done");
    $("#question-" + nextIndex).addClass("active");
    $("#question-" + nextIndex).addClass("done");
  }

  mimicHover(e, $el) {
    const $parent = $el.parents(".slider__input");
    const $thumb = $parent.find(".slider__point");
    const thumbLeft = $thumb.offset().left;
    const thumbWidth = 30;
    const maxLeft = thumbLeft + thumbWidth;
    const x = window.event;
    // @ts-ignore
    const posX = x.clientX;

    if (posX <= maxLeft && posX >= thumbLeft) {
      $thumb.addClass("is-transitioning");
    } else {
      $thumb.removeClass("is-transitioning");
    }
  }

  onSubmit() {
    $(this.elms.btnSubmit).addClass("is-loading");
    $("#pageWrapper").addClass("is-loading");

    let postData = {
      test_type: this._data.test_type,
      data: this._data.pre_post_value,
    };

    bdapi.post("game/test", postData).catch(() => {});

    BD_GAME_LOGIC.goToDefaultNextBlock();
  }

  onFinish() {}
}
